import axios, { type AxiosError } from 'axios';

import type { CustomsHarmonizationCodeData } from '../../types';

const API_ERROR_CODE = {
  VALIDATION_ERROR: 'validation_error',
  HS_CODE_LOOKUP_INSUFFICIENT_DESCRIPTION: 'hs_code_lookup_insufficient_description',
} as const;

export const SIMPLIFIED_ERROR_CODE = {
  INSUFFICIENT_DESCRIPTION: 'hsCodeInsufficientDescriptionError',
  GENERAL_ERROR: 'hsCodeGeneralError',
} as const;

const INSUFFICIENT_DESCRIPTION_ERROR_CODES: string[] = [
  API_ERROR_CODE.VALIDATION_ERROR,
  API_ERROR_CODE.HS_CODE_LOOKUP_INSUFFICIENT_DESCRIPTION,
];

export const lookupHarmonizationCode = async (description: string): Promise<CustomsHarmonizationCodeData> => {
  try {
    const response = await axios.post<CustomsHarmonizationCodeData>('customs/harmonizationCode/lookup', { description });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<CustomsHarmonizationCodeData>;
    const apiErrorCode = axiosError?.response?.data?.errorCode;
    const errorCode = INSUFFICIENT_DESCRIPTION_ERROR_CODES.includes(apiErrorCode ?? '')
      ? SIMPLIFIED_ERROR_CODE.INSUFFICIENT_DESCRIPTION
      : SIMPLIFIED_ERROR_CODE.GENERAL_ERROR;

    return {
      ...axiosError.response?.data,
      errorCode,
    };
  }
};
